import React, { useState, useEffect, useRef } from "react";
import { withStyles, Dialog, Checkbox } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Auth from "../utils/auth";

import {
  PermIdentityOutlined,
  VisibilityOff,
  Visibility,
  LockOutlined,
  VpnKeyOutlined,
} from "@material-ui/icons";
import Loader from "../components/Loader";

import { images } from "../utils/images";
import {
  requestSignIn,
  getAccount,
  submitIpConfirmation,
  showIPForm,
  pushNotification,
  requestSignOut,
  cleanTemporaryAcc,
  rejectTerms,
  requestAcceptNewTerms,
  fillAcceptNewTerms,
  fillLoginError,
  fillIpConfirmation,
} from "../actions/index";
import ReCAPTCHA from "react-google-recaptcha";

const sitekey = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_CAPTCHA_SITEKEY;

const dashboard_url = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_DASHBOARD;

const ops_url = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_OPS_URL;

const uac_url = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_UAC_URL;

function LoginScreen(props) {
  const {
    classes,
    t,
    i18n,
    account,
    toggleIPForm,
    ipConfirmation,
    termsVersion,
    acceptNewTerms,
    temporaryAcc,
    loginError,
  } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [logginIn, setLoggingIn] = useState(false);
  const [ipConfirming, setIpConfirming] = useState(false);
  const [acquiredCaptcha, setAcquiredCaptcha] = useState(false);
  const [captchaReady, setCaptchaReady] = useState(true);
  const [ipCode, setIPCode] = useState("");
  const [ipConfirmed, setIpConfirmed] = useState(false);
  const [disabledLoginBtn, setDisabledLoginBtn] = useState(true);
  const [openLinksModal, toggleLinkModal] = useState(false);
  const captchaRef = useRef();

  const [terms, toggleTerms] = useState(false);
  const [privacy, togglePrivacy] = useState(false);

  const [openAccModal, setOpenAccModal] = useState(false);

  useEffect(() => {
    return () => {
      setEmail("");
      setPassword("");
      setAcquiredCaptcha(false);
      setCaptchaReady(false);
      setOtp(false);
      setIpConfirming(false);
      props.showIPForm(false);
    };
  }, []);

  const requestSignIn = async () => {
    setLoggingIn(true);

    if (!acquiredCaptcha) {
      await getCaptcha();
    }

    if (captchaRef.current) {
      const token = captchaRef.current.getValue();

      if (token.length) {
        let obj = {
          credentials: {
            email: email.trim(),
            password: password,
            otp: otp.trim(),
            "g-recaptcha-response": token,
          },
          termsVersion: termsVersion,
        };

        props.requestSignIn(obj);
      }
    }
  };
  const getCaptcha = async () => {
    setCaptchaReady(false);
    captchaRef.current.reset();
    try {
      await captchaRef.current.executeAsync();
      setAcquiredCaptcha(true);
      setCaptchaReady(true);
    } catch (e) {
      setLoggingIn(false);
      return props.pushNotification({
        message: "Can't connect to Google ReCaptcha",
        type: "error",
      });
    }
  };

  const openCreatingAccModal = () => {
    setOpenAccModal(true);
  };

  useEffect(() => {
    if (loginError) {
      setAcquiredCaptcha(false);
      setLoggingIn(false);
      props.fillLoginError(false);
    }
  }, [loginError]);

  useEffect(() => {
    if (account.account !== null) {
      if (account.account.terms_version < termsVersion) {
        // setOpenNewTerms(true);
        return;
      }

      if (account.account.role !== "member") {
        toggleLinkModal(true);
      } else {
        // if (account.account.level < 5) {
        //   if (
        //     account.account.profile &&
        //     account.account.profile.status === "level_6_pending"
        //   ) {
        //     return;
        //   }
        //   props.history.push("/id/verification");
        //   return;
        // } else {
        props.pushNotification({
          message: "login_success_notification",
          type: "success",
        });

        setTimeout(function () {
          Auth.redirectToDashboard();
        }, 1000);
        // }
      }

      // if (account.account.level < 5) {
      //   if (
      //     account.account.profile &&
      //     account.account.profile.status === "level_6_pending"
      //   ) {
      //     return;
      //   }
      //   props.history.push("/id/verification");
      //   return;
      // } else {
      //   if (account.account.role === "member") {
      //     props.pushNotification({
      //       message: "login_success_notification",
      //       type: "success",
      //     });

      //     setTimeout(function () {
      //       Auth.redirectToDashboard();
      //     }, 1000);
      //   } else {
      //     toggleLinkModal(true);
      //     // props.pushNotification({
      //     //   message: "login_success_notification",
      //     //   type: "success",
      //     // });

      //     // setTimeout(function () {
      //     //   Auth.redirectToDashboard();
      //     // }, 1000);
      //   }
      // }
    } else {
      setEmail("");
      setPassword("");
      setOtp("");
      setAcquiredCaptcha(false);
    }
  }, [account]);

  useEffect(() => {
    if (ipConfirmation !== null) {
      setAcquiredCaptcha(false);
      setIpConfirming(false);
      if (ipConfirmation === "ip_confirmed") {
        props.showIPForm(false);
        setLoggingIn(false);
        setIpConfirmed(true);
        setPassword("");
      } else {
        props.pushNotification({
          message: "Invalid confirmation code",
          type: "error",
        });
      }
      props.fillIpConfirmation(null);
    }
    return () => {};
  }, [ipConfirmation]);

  useEffect(() => {
    if (email.length && password.length) {
      setAcquiredCaptcha(false);
      setLoggingIn(false);
      setDisabledLoginBtn(false);
    }
  }, [email, password]);

  useEffect(() => {
    if (toggleIPForm) {
      setAcquiredCaptcha(false);
    }
  }, [toggleIPForm]);

  const submitIPverification = async () => {
    setIpConfirming(true);

    props.submitIpConfirmation({
      email: email,
      verification_code: ipCode.trim(),
    });
  };

  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (email.length && password.length && captchaReady && !logginIn) {
        requestSignIn();
      }
    }
  };

  const rejectNewTerms = () => {
    captchaRef.current.reset();
    setAcquiredCaptcha(false);
    setCaptchaReady(false);
    setPassword("");
    setLoggingIn(false);
    props.rejectTerms();
    props.cleanTemporaryAcc();
  };
  const agreeToTerms = async () => {
    await props.fillAcceptNewTerms(false);
    await props.requestAcceptNewTerms(temporaryAcc);
    props.cleanTemporaryAcc();
  };

  return (
    <div className={classes.firstScreen}>
      <div className="leftSideLogin">
        <img className="smallLogo" src={images.logos.sologenicWhiteLogo} />
        {toggleIPForm ? (
          <div className="signingInContainer ipContainer">
            <p className="ipCopyVerification">{t("_ipVerificationCopy")}</p>
            <div className="inputsContainer">
              <input
                type="text"
                placeholder={t("_enterIpCode")}
                pattern="[0-9]"
                minLength="6"
                onChange={(e) => setIPCode(e.target.value)}
              />
            </div>
            <button
              className={"soloSignInBtn"}
              disabled={ipCode === "" ? true : ipConfirming ? true : false}
              onClick={() => submitIPverification()}
            >
              {t("submit")}
            </button>
          </div>
        ) : (
          <div
            className="signingInContainer"
            onKeyDown={(e) => _handleKeyDown(e)}
          >
            <p>{t("loginCopy")}</p>
            {ipConfirmed ? (
              <p className={classes.ipConfirmed}>{t("_ipConfirmed")}</p>
            ) : (
              ""
            )}
            <div className="inputsContainer">
              <div className="inputDiv">
                <input
                  onChange={(e) => setEmail(e.currentTarget.value)}
                  type="email"
                  placeholder={t("usernamePlaceholder")}
                  value={email}
                />
              </div>
              <div className="inputDiv">
                <input
                  onChange={(e) => setPassword(e.currentTarget.value)}
                  type={showPassword ? "text" : "password"}
                  placeholder={t("passwordPlaceholder")}
                  value={password}
                />
                {showPassword ? (
                  <VisibilityOff onClick={() => setShowPassword(false)} />
                ) : (
                  <Visibility onClick={() => setShowPassword(true)} />
                )}
              </div>
              <div className="inputDiv">
                <input
                  onChange={(e) => setOtp(e.currentTarget.value)}
                  type="text"
                  placeholder={t("otpPlaceholder")}
                />
              </div>
            </div>
            <ReCAPTCHA
              ref={captchaRef}
              sitekey={sitekey}
              theme="dark"
              size="invisible"
            />
            <button
              className={"soloSignInBtn"}
              id="signingInBtn"
              disabled={disabledLoginBtn || logginIn}
              onClick={() => requestSignIn()}
            >
              {logginIn ? t("signIn") : t("signIn")}
            </button>
            <div className="helpLinks">
              <p>
                <Link to="/id/password_reset">{t("forgotPassword")}</Link>
              </p>
              <p className="signUpLink">
                {t("noAccount")}{" "}
                <Link to="/id/signup">{t("_createAnAccount")}</Link>
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="rightSideLogin">
        <img className="logo" src={images.logos.sologenicWhiteLogo} />
        <h1>{t("_welcomeBackSolo")}</h1>
        <p
          className="brand_is"
          dangerouslySetInnerHTML={{
            __html: t("_soloIs"),
          }}
        />
        <p className="newToCf">
          {t("_newToSOLO")} <Link to="/id/signup">{t("_createAnAccount")}</Link>
        </p>
        <img className="world" src={images.illustrations.loginIllustration} />
      </div>

      <Dialog
        open={acceptNewTerms}
        classes={{ paper: classes.modal }}
        scroll="body"
      >
        <div className="modalHeader">
          <p>{t("_soloTerms")}</p>
        </div>
        <div className="modalBody">
          <p
            className="contentTerms"
            dangerouslySetInnerHTML={{
              __html: t("_soloTermsCopy"),
            }}
          />
          <div className="checkbox">
            <Checkbox
              classes={{ checked: classes.checkbox }}
              onClick={() => toggleTerms(!terms)}
              checked={terms}
            />
            <p
              dangerouslySetInnerHTML={{
                __html: t("_iAcceptSoloTerms"),
              }}
            />
          </div>
          <div className="checkbox">
            <Checkbox
              classes={{ checked: classes.checkbox }}
              onClick={() => togglePrivacy(!privacy)}
              checked={privacy}
            />
            <p
              dangerouslySetInnerHTML={{
                __html: t("_iAcceptSoloPrivacy"),
              }}
            />
          </div>
          <div className="btns">
            <button onClick={() => rejectNewTerms()}>{t("_iReject")}</button>
            <button
              disabled={!terms || !privacy}
              onClick={() => agreeToTerms()}
            >
              {t("_iAgree")}
            </button>
          </div>
        </div>
      </Dialog>
      {openLinksModal ? (
        <Dialog open classes={{ paper: classes.modal }} scroll="body">
          <div className="modalHeader">
            <p>
              {t("_welcomeAdmin", {
                name: account.account?.profile?.first_name
                  ? account.account.profile.first_name
                  : "Admin",
              })}
            </p>
          </div>
          <div className="modalBody">
            <div className="links_admin">
              <a href={dashboard_url}>
                <p>{t("_dashboard")}</p>
              </a>
              <a
                href={ops_url + "sign_in#" + localStorage.token}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>Admin</p>
              </a>
              <a href="/id/settings">
                <p>{t("_settings")}</p>
              </a>
            </div>
          </div>
        </Dialog>
      ) : (
        ""
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
    toggleIPForm: state.toggleIPForm,
    ipConfirmation: state.ipConfirmation,
    termsVersion: state.termsVersion,
    acceptNewTerms: state.acceptNewTerms,
    temporaryAcc: state.temporaryAcc,
    loginError: state.loginError,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      requestSignIn,
      getAccount,
      submitIpConfirmation,
      showIPForm,
      pushNotification,
      requestSignOut,
      requestAcceptNewTerms,
      fillAcceptNewTerms,
      cleanTemporaryAcc,
      rejectTerms,
      fillLoginError,
      fillIpConfirmation,
    },
    dispatch
  );
}

const styles = function (theme) {
  return {
    firstScreen: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",

      "& .leftSideLogin": {
        background: theme.colors.background.main,
        width: "60%",
        height: "100%",
        minHeight: 850,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",

        "& .smallLogo": {
          display: "none",
          width: 180,
          height: "auto",
          marginTop: 24,
          marginBottom: 32,
        },

        "& .signingInContainer": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px 80px",
          background: theme.colors.background.fore,
          borderRadius: 2,
          boxShadow: theme.defaults.shadow,
          width: "90%",
          maxWidth: 560,
          height: "auto",
          marginTop: 24,

          [theme.breakpoints.down(370)]: {
            width: "100%",
            padding: "40px 0",
            boxShadow: "none",
            borderRadius: 0,
          },

          "& p": {
            color: theme.colors.text.primary,
            marginBottom: 40,
            textAlign: "center",
            lineHeight: "21px",
            fontSize: 28,
            fontWeight: 600,
          },
          "& .signInBtn, & .soloSignInBtn": {
            ...theme.defaults.squareBtn,
            background: theme.colors.buttons.green,
            fontWeight: 700,
            marginTop: 75,
            width: "100%",
          },
          "& .soloSignInBtn": {
            borderRadius: 25,
            maxWidth: 150,
          },
          "& .signUpLink": {
            display: "none",
            [theme.breakpoints.down(900)]: {
              display: "block",
            },
          },

          "& .inputsContainer": {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            "& input": {
              ...theme.defaults.input,
              color: theme.colors.text.primary,
              // "&:focus": {
              //   border: `1px solid ${theme.colors.text.primary}`,
              //   fontSize: 18,
              //   fontWeight: 500,
              // },
            },

            "& .inputDiv": {
              position: "relative",
              margin: "8px 0",
              width: "auto",
              "&:first-of-type": {
                marginTop: 0,
              },
              "& input": {
                maxWidth: "none",
                width: 400,
                [theme.breakpoints.down(450)]: {
                  width: 300,
                },
              },
              "& svg": {
                position: "absolute",
                top: "50%",
                color: theme.colors.text.secondary,
                right: 0,
                transform: "translate(-100%, -50%)",
                cursor: "pointer",
              },
            },
          },
          "& .helpLinks": {
            marginTop: 32,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            "& p": {
              marginBottom: 0,
              fontSize: 14,
              "&:first-of-type": {
                marginBottom: 12,
              },
              "& a, & button": {
                ...theme.defaults.link,
                fontWeight: 600,
                background: "none",
                padding: 0,
                border: "none",
              },
            },
          },
          "&.ipContainer": {
            height: "auto",
            padding: "40px 80px",
            [theme.breakpoints.down(475)]: {
              padding: "40px 16px",
            },
            "& .ipCopyVerification": {
              fontSize: 16,
              lineHeight: "30px",
            },
            "& input": {
              marginBottom: 12,
              maxWidth: "none !important",
            },
          },
        },
      },
      "& .rightSideLogin": {
        width: "40%",
        height: "100%",
        minHeight: 850,
        background: theme.colors.background.fore,
        padding: "120px 40px 0 80px",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",

        "& .world": {
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "80%",
          maxWidth: 440,
          transform: "translateY(40%)",
        },

        "& .logo": {
          width: 185,
          height: "auto",
        },
        "& h1": {
          fontSize: 48,
          fontWeight: 700,
          width: "70%",
          marginTop: 72,
          marginBottom: 16,
          color: theme.colors.text.primary,
        },

        "& p": {
          fontSize: 20,
          lineHeight: "30px",
          color: theme.colors.text.secondary2,
          "&.brand_is": {
            "& b": {
              color: theme.colors.background.active,
            },
          },
        },

        "& .newToCf": {
          marginTop: 32,
          fontSize: 28,
          "& a, & button": {
            ...theme.defaults.link,
            fontWeight: 600,
            background: "none",
            padding: 0,
            border: "none",
          },
        },
      },

      [theme.breakpoints.down(900)]: {
        flexDirection: "column",
        "& .leftSideLogin": {
          width: "100%",
          justifyContent: "flex-start",
          "& .smallLogo": {
            display: "block !important",
          },
        },
        "& .rightSideLogin": {
          display: "none",
        },
      },
    },
    ipConfirmed: {
      color: `${theme.colors.buttons.buy} !important`,
      fontSize: `14px !important`,
      // fontFamily: "Titillium Web",
      lineHeight: "21px",
      marginBottom: 12,
      textAlign: "center",
    },
    modal: {
      background: theme.colors.background.fore,
      borderRadius: 2,
      width: "95%",
      maxWidth: "650px !important",
      margin: 0,
      "& .modalHeader": {
        background: theme.colors.background.lightFore,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.colors.text.primary,
        fontWeight: 600,
        height: 75,
        fontSize: 18,
        boxShadow: `0 2px 4px #D6D6D6`,
      },
      "& .modalBody": {
        padding: "40px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: theme.colors.text.primary,

        "& .contentTerms": {
          lineHeight: "21px",
          marginBottom: 24,
          "& a": {
            ...theme.defaults.link,
          },
        },

        "& .checkbox": {
          display: "flex",
          alignItems: "center",
          width: "100%",

          "& a": {
            ...theme.defaults.link,
          },
        },

        "& .btns": {
          marginTop: 40,
          "& button": {
            ...theme.defaults.roundBtn,
            background: theme.colors.buttons.green,
            "&:first-of-type": {
              marginRight: 8,
              background: "none",
              borderColor: theme.colors.text.primary,
              color: theme.colors.text.primary,
            },
          },
        },
        "& .links_admin": {
          display: "flex",
          justifyContent: "space-between",
          width: "100%",

          "& a": {
            width: "30%",
            textDecoration: "none",
            color: theme.colors.text.primary,
          },
          "& p": {
            height: 52,
            width: "100%",
            borderRadius: 2,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            transition: ".3s",
            border: `1px solid ${theme.colors.misc.dividers}`,
            "&:hover": {
              boxShadow: theme.defaults.shadow,
            },
          },
        },
      },
    },
    checkbox: {
      color: `${theme.colors.buttons.green} !important`,
    },
    accModal: {
      width: "100%",
      maxWidth: `550px !important`,
      background: theme.colors.background.main,
      color: theme.colors.text.primary,
      padding: "40px 80px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: 0,
      [theme.breakpoints.down(600)]: {
        padding: "40px 24px",
      },
      "& p": {
        marginBottom: 24,
        fontSize: 32,
        textAlign: "center",
        "&:nth-of-type(2)": {
          lineHeight: "21px",
          fontSize: 16,
        },
      },
      "& button": {
        background: theme.colors.background.active,
        height: 55,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 16,
        border: "none",
        width: "100%",
        textTransform: "uppercase",
        cursor: "pointer",
        transition: ".3s",
        "& img": {
          marginRight: 8,
          height: "auto",
          width: 24,
          objectFit: "auto",
        },
        "&:hover": {
          opacity: 0.5,
        },
      },
      "& a": {
        border: `1px solid ${theme.colors.background.active}`,
        height: 55,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        textTransform: "uppercase",
        color: theme.colors.text.primary,
        textDecoration: "none",
        transition: ".3s",
        "&:hover": {
          opacity: 0.5,
        },
      },
    },
  };
};

export default withRouter(
  withStyles(styles)(
    withTranslation()(connect(mapStateToProps, mapDispatchToProps)(LoginScreen))
  )
);
